/* eslint-disable import/no-anonymous-default-export */
import { combineReducers } from "redux-immutable";
import { connectRouter } from "connected-react-router";
import appReducer from "./app-reducer";
import dataBlog from "./blog-reducer";
import campaignReducer from "./campaign-reducer";
import storeReducer from "./store-reducer";
import reportReducer from "./report-reducer";

export default (history) =>
  combineReducers({
    router: connectRouter(history),
    appReducer,
    dataBlog,
    campaignReducer,
    storeReducer,
    reportReducer,
  });
